export default __webpack_public_path__ + "static/media/appliances_cat_disabled.6c64f191.jpg";